import { useState } from "react";
import { message, Space, Table } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { format } from "date-fns";
import DeleteButton from "../UI/DeleteButton/deletebutton";
import ViewButton from "../UI/ViewButton/viewbutton";
import DeleteModal from "../UI/ModalComponent/DeleteModal/deletemodal";
import { BalanceListPropsInterface } from './types'
import { useMutation } from "react-query";
import { deleteSupplierTransaction } from "../../api/supplier";

export const BalanceList = ({
  supplierBalance,
  setSupplierBalance,
  supplierBalanceLoading,
  getSupplierBalanceMutation,
  pagination,
  setPagination,
  from,
  to,
  handleTableChange
}: BalanceListPropsInterface) => {

  const [t] = useTranslation("common");
  const [open, setOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<any>();
  const navigate = useNavigate();

  const { mutateAsync: deleteSupplierMutation } = useMutation("deleteSupplier", ({ id, type }: { id: number | string, type: string }) => deleteSupplierTransaction({ id, type }), {
    onSuccess: async ({ data }) => {
      message.success(data.message)
      if (data.total !== pagination.total) {
        setPagination((prevPagination: any) => ({
          ...prevPagination,
          total: data.total,
          current: 1
        }));
        setSupplierBalance(data?.data);
      }
    }
  });

  const handleDelete = (record: any): void => {
    setOpen(true);
    setItemToDelete(record)
  };

  const handleOk = () => {
    deleteSupplierMutation({ type: itemToDelete.transaction.type, id: itemToDelete.transaction.id })
    setOpen(false);
  };

  const handleView = (id: number | null, type: string): void => {
    type = type.toLowerCase();

    const typeToPathMap: Record<string, string> = {
      'beginning balance': '',
      'bill': '/bills',
      'bill return': '/return',
      'payment': '/supplierpayment'
    };

    const path = typeToPathMap[type];

    if (!path) return

    navigate(path, { state: { id } });
  }

  const columns: {}[] = [
    {
      title: `${t("transaction-type")}`,
      dataIndex: "transaction",
      key: "transaction",
      className: "table-header",
      render: (record: any) => {
        return record.type;
      },
    },
    {
      title: `${t("date")}`,
      dataIndex: "date",
      key: "date",
      render: (date: any) => {
        return format(new Date(date), "MM/dd/yyyy HH:mm");
      },
    },
    {
      title: `${t("payment-mode")}`,
      dataIndex: "paymentMode",
      key: "paymentMode",
      render: (record: any) => {
        return record ? record.mode : null;
      },
    },
    {
      title: `${t("amount")}`,
      dataIndex: "amountText",
      key: "amountText",
    },
    {
      title: `${t("running-balance")}`,
      dataIndex: "runningBalanceText",
      key: "runningBalanceText",
    },
    {
      title: `${t("notes")}`,
      dataIndex: "notes",
      key: "notes",
    },
    {
      title: `${t("action")}`,
      key: "action",
      width: "7rem",
      align: "center",
      render: (record: any) => (
        <Space>
          {/* <PrintButton onClick={() => { }} /> */}
          <ViewButton
            onClick={() => {
              handleView(record?.transaction?.id, record?.transaction?.type);
            }}
          />
          <DeleteButton
            onClick={() => {
              handleDelete(record)
            }}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <DeleteModal
        open={open}
        setOpen={setOpen}
        name={'name'}
        onOk={handleOk}
      />
      <Table
        loading={supplierBalanceLoading}
        columns={columns}
        dataSource={supplierBalance}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        pagination={{ ...pagination, showSizeChanger: false }}
        onChange={handleTableChange}
      />
    </>
  );
};
